/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
/**
 * 
 * @export
 * @interface GetDemoConvSignedUrlResponse
 */
export interface GetDemoConvSignedUrlResponse {
    /**
     * 
     * @type {string}
     * @memberof GetDemoConvSignedUrlResponse
     */
    data?: string;
    /**
     * 
     * @type {number}
     * @memberof GetDemoConvSignedUrlResponse
     */
    totalRecords?: number;
    /**
     * 
     * @type {number}
     * @memberof GetDemoConvSignedUrlResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof GetDemoConvSignedUrlResponse
     */
    pages?: number;
    /**
     * 
     * @type {Array<Error>}
     * @memberof GetDemoConvSignedUrlResponse
     */
    errors?: Array<Error>;
}

/**
 * Check if a given object implements the GetDemoConvSignedUrlResponse interface.
 */
export function instanceOfGetDemoConvSignedUrlResponse(value: object): boolean {
    return true;
}

export function GetDemoConvSignedUrlResponseFromJSON(json: any): GetDemoConvSignedUrlResponse {
    return GetDemoConvSignedUrlResponseFromJSONTyped(json, false);
}

export function GetDemoConvSignedUrlResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetDemoConvSignedUrlResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : json['data'],
        'totalRecords': json['totalRecords'] == null ? undefined : json['totalRecords'],
        'page': json['page'] == null ? undefined : json['page'],
        'pages': json['pages'] == null ? undefined : json['pages'],
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function GetDemoConvSignedUrlResponseToJSON(value?: GetDemoConvSignedUrlResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': value['data'],
        'totalRecords': value['totalRecords'],
        'page': value['page'],
        'pages': value['pages'],
        'errors': value['errors'],
    };
}

